<template>
  <div class="top5">
    <div class="top5__header" v-if="top5 && top5.length > 0">%</div>
    <div
      :class="[
        'top5__item',
        {
          isOther: isOthers(item),
          active: isActive(item),
          inActive: isInactive(item),
        },
      ]"
      v-for="(item, index) in top5"
      :key="index"
      @mouseenter="onHoverItem(item, true)"
      @mouseleave="onHoverItem(item, false)"
    >
      <div class="top5__item--rank">
        {{ item.RANK }}
      </div>
      <div class="top5__item--label">
        <div class="value">{{ item["QTY%"].toFixed(1) + "%" }}</div>
        <div class="country">{{ countryLabel(item) }}</div>
      </div>
    </div>
    <div v-if="top5 && top5.length == 0">No data</div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Top5",
  data() {
    return {
      hoverId: null,
    };
  },
  methods: {
    isOthers(item) {
      return (
        item.COUNTRY.toLowerCase() === "others" ||
        item.COUNTRY === "Rest of the World"
      );
    },
    countryLabel(item) {
      //[NB] QUI DA MOCKUP CI ANDREBBE REST OF THE WORLD MA NON è SEMPRE VERO, SE HO SELEZIONATO GEO AREA DOVREBBE ESSERCI REST OF THE EUROPE PER ESEMPIO
      // PER ORA LASCIO OTHERS PER TUTTI I CASI POI VEDREMO
      return this.isOthers(item) ? "Others: " : item.COUNTRY;
    },
    onHoverItem(item, active) {
      // disable  hover for others
      if (this.isOthers(item)) {
        return;
      }

      this.hoverId = active ? item.GEO.id : null;

      this.setSelectedCountryId(this.hoverId);
    },
    isActive(item) {
      return this.hoverId !== null && this.hoverId === item.GEO.id;
    },
    isInactive(item) {
      return this.hoverId !== null && this.hoverId !== item.GEO.id;
    },

    ...mapActions({
      setSelectedCountryId: "ui/setSelectedCountryId",
    }),
  },
  computed: {
    ...mapGetters({
      top5: "data/getTop5",
      selectedCountryId: "ui/selectedCountryId",
    }),
  },
  watch: {
    selectedCountryId(newVal) {
      // console.log("newVal", newVal);
      this.hoverId = newVal;
    },
    top5(newVal) {
      console.log(newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.top5 {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
  width: 20%;
  color: $ui-white;
  border-left: $white-border;
  background-color: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);

  &__header {
    display: flex;
    flex-direction: row;
    height: toRem(40);
    padding: toRem(5) toRem(10);
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border-bottom: $white-border;
  }

  &__item {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-bottom: $white-border;
    border-left: none;
    flex-grow: 1;
    transition: background-color 0.2s ease;

    &.active {
      backdrop-filter: blur(20px);
      background-color: var(--white_01);
    }

    &.inActive {
      opacity: 0.2;
      backdrop-filter: blur(20px);
    }

    &--rank {
      width: toRem(70);
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      @include title-H6;
      color: $ui-white;
      border-right: $white-border;
      flex-shrink: 0;

      .isOther & {
        display: none;
      }
    }

    &--label {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      flex-grow: 1;
      padding: 0 toRem(15);

      .isOther & {
        flex-direction: row-reverse;
        justify-content: flex-end;
        opacity: 0.7;
        .value {
          color: $ui-white;
          @include dida-S;
          margin: 0 5px;
        }
      }

      .value {
        @include number-S;
        color: $primary-yellow;
      }

      .country {
        @include dida-S;
        color: $ui-white;
      }
    }
  }
}
</style>
